import React from 'react';
import { ChipBase } from '../chip-base/chip-base';
export const ChipSearch = ({ content, ...restProps }) => {
    return (React.createElement(ChipBase, { size: "s", content: [
            {
                text: content,
                style: 'regular',
            },
        ], variant: "search", ...restProps }));
};
//# sourceMappingURL=chip-search.js.map